import { jwtDecode } from 'jwt-decode';

/**
 * The `id` claim of an access token, or `undefined` when it cannot be read.
 *
 * Never throws: `jwtDecode` rejects anything that is not a well-formed JWT, and the callers of this
 * run on every render of the provider that gates the whole app. Expiry is not checked because the
 * claim set does not carry one — only `iat`, `id`, `username`, `isNightgraphUser` and `isAdmin`.
 */
export const getTokenUserId = (token?: string): string | undefined => {
  if (!token) return undefined;

  try {
    return jwtDecode<{ id?: string }>(token).id;
  } catch {
    return undefined;
  }
};
